import styles from './Pill.module.css';

function Pill({text}) {
    return (
        <div className={styles.container}>
            {text}
        </div>
    )
}

export default Pill;